import '@hotwired/turbo-rails';
Turbo.session.drive = false

import * as ActiveStorage from '@rails/activestorage';

ActiveStorage.start();

// GLOBALS

import '@/vendor/handlebars';
import '@/vendor/jquery';

import Rails from '@rails/ujs';

Rails.start();

import '@/vendor/complety';
import '@/vendor/jquery.gridy';
import '@/vendor/jquery.magnific-popup';
import '@/vendor/jquery.maskMoney';
import '@/vendor/jquery.notify';
import '@/vendor/jquery.validaty';
import '@/vendor/jquery.validaty.validators'; // after: @/vendor/jquery.validaty

import '@/controllers/site';

// ON READY

import boot from '@/pages/site/boot';
import onReady from '@/modules/on_ready';

// CI

import '@/modules/ci';

// RUN

onReady(boot);
